<template>
<div style="width:100%">
  <v-sheet :color="colores.primario" style="padding:1px" rounded>
    <v-card flat>
      <v-toolbar dense flat><span :style="[{'color': colores.primario},{'font-size': '20px'}]"><b>RESPUESTA CASOS TUTELA</b></span></v-toolbar>
      <v-card-text class="pt-0">
        <v-row no-gutters>
          <v-col cols="12" md="6">
            <v-autocomplete v-model="form_tutela.resultado_id" :items="items.items_fallotutela" item-text="descripcion" item-value="id" label="RESULTADO FALLO TUTELA"></v-autocomplete>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-sheet>
</div>
</template>

<script>
export default {
  name: 'form_qr_cierreComponent',
  components: {
  },
  props: ['colores', 'rules', 'items', 'form_tutela'],
  data: () => ({

  }),
  methods: {

  }
}
</script>
